var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1506",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1506",
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 80,
    viewBox: "0 0 165 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_117",
    "data-name": "\\u9577\\u65B9\\u5F62 117",
    width: 165,
    height: 80,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1505",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1505",
    transform: "translate(39.231 27.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_801",
    "data-name": "\\u30D1\\u30B9 801",
    d: "M271.5,174.01l1.251,1.251a5.536,5.536,0,0,1-6.732.63,2.034,2.034,0,0,0,.181,2.657l2.554,2.554a2.037,2.037,0,0,0,2.868,0l2.554-2.554a2.037,2.037,0,0,0,0-2.868l-2.554-2.554a2.037,2.037,0,0,0-2.868,0l-1.457,1.457a3.777,3.777,0,0,0,4.2-.574Z",
    transform: "translate(-230.885 -151.585)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_802",
    "data-name": "\\u30D1\\u30B9 802",
    d: "M264.028,162.717a3.821,3.821,0,0,0,.515,1.9l1.507-1.507a4.238,4.238,0,0,1,.452-.391,4.228,4.228,0,0,1-.452-.391l-1.506-1.507a3.818,3.818,0,0,0-.515,1.9Z",
    transform: "translate(-229.744 -143.13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_803",
    "data-name": "\\u30D1\\u30B9 803",
    d: "M265.61,145.995a2.015,2.015,0,0,0,.41,1.223,5.536,5.536,0,0,1,6.732.63L271.5,149.1a3.778,3.778,0,0,0-4.2-.573l1.457,1.457a2.037,2.037,0,0,0,2.868,0l2.554-2.554a2.015,2.015,0,0,0,.59-1.434c0-.04-.009-.077-.011-.116h-9.134C265.619,145.918,265.61,145.955,265.61,145.995Z",
    transform: "translate(-230.885 -132.35)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_804",
    "data-name": "\\u30D1\\u30B9 804",
    d: "M209.3,145.936c0,2.183,1.164,3.492,3.318,3.492a4.1,4.1,0,0,0,3.8-3.549H209.3Z",
    transform: "translate(-190.255 -132.35)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_805",
    "data-name": "\\u30D1\\u30B9 805",
    d: "M334.773,130.444a2.038,2.038,0,0,0-2.868,0l-2.014,2.014h6.9Z",
    transform: "translate(-277.268 -120.787)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_806",
    "data-name": "\\u30D1\\u30B9 806",
    d: "M331.724,174.01l1.251,1.251a5.536,5.536,0,0,1-6.732.63,2.035,2.035,0,0,0,.18,2.657l2.554,2.554a2.037,2.037,0,0,0,2.868,0l2.554-2.554a2.038,2.038,0,0,0,0-2.868l-2.554-2.554a2.038,2.038,0,0,0-2.868,0l-1.457,1.457a3.777,3.777,0,0,0,4.2-.574Z",
    transform: "translate(-274.34 -151.585)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_807",
    "data-name": "\\u30D1\\u30B9 807",
    d: "M324.252,162.717a3.822,3.822,0,0,0,.515,1.9l1.507-1.507a4.239,4.239,0,0,1,.452-.391,4.229,4.229,0,0,1-.452-.391l-1.507-1.507a3.822,3.822,0,0,0-.515,1.9Z",
    transform: "translate(-273.199 -143.13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_808",
    "data-name": "\\u30D1\\u30B9 808",
    d: "M274.549,130.444a2.037,2.037,0,0,0-2.868,0l-2.015,2.014h6.9Z",
    transform: "translate(-233.812 -120.787)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_809",
    "data-name": "\\u30D1\\u30B9 809",
    d: "M325.834,145.995a2.015,2.015,0,0,0,.41,1.223,5.536,5.536,0,0,1,6.732.63l-1.251,1.251a3.778,3.778,0,0,0-4.2-.573l1.457,1.457a2.037,2.037,0,0,0,2.868,0l2.554-2.554a2.016,2.016,0,0,0,.59-1.434c0-.04-.009-.077-.011-.116h-9.134C325.843,145.918,325.834,145.955,325.834,145.995Z",
    transform: "translate(-274.34 -132.35)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_810",
    "data-name": "\\u30D1\\u30B9 810",
    d: "M418.627,124.439c-2.136,0-3.738,1.349-4.1,3.991h8.093C422.421,125.816,420.875,124.439,418.627,124.439Z",
    transform: "translate(-338.336 -116.88)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_811",
    "data-name": "\\u30D1\\u30B9 811",
    d: "M375.842,139.207H364.918a4.22,4.22,0,0,1,.479,1.858h10.418c-.023-.259-.035-.526-.035-.8A9.19,9.19,0,0,1,375.842,139.207Z",
    transform: "translate(-302.542 -127.536)",
    fill: "#fbc513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_812",
    "data-name": "\\u30D1\\u30B9 812",
    d: "M251.238,141.065h9.134a2,2,0,0,0-.579-1.318l-.54-.54H245.677v1.858h5.561Z",
    transform: "translate(-216.502 -127.536)",
    fill: "#fbc513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_813",
    "data-name": "\\u30D1\\u30B9 813",
    d: "M310.591,141.065h9.134a2.005,2.005,0,0,0-.579-1.318l-.54-.54H304.694a4.22,4.22,0,0,1,.479,1.858h5.419Z",
    transform: "translate(-259.087 -127.536)",
    fill: "#fbc513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_814",
    "data-name": "\\u30D1\\u30B9 814",
    d: "M193.068,141.065h7.115a5.259,5.259,0,0,0,.1-1.02v-.838H186.8v1.858h6.264Z",
    transform: "translate(-174.022 -127.536)",
    fill: "#fbc513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_815",
    "data-name": "\\u30D1\\u30B9 815",
    d: "M151.795,136.974l-2.135-.4,2.135-.4v-2.062l-5.644,2.465,5.644,2.466Z",
    transform: "translate(-144.688 -123.854)",
    fill: "#fbc513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_816",
    "data-name": "\\u30D1\\u30B9 816",
    d: "M149.466,118.666c0,2.674-1.128,3.834-3.415,3.834-1.836,0-3.64-1.1-5.155-2.062v3.125a9.554,9.554,0,0,0,5.155,1.675c4.607,0,6.733-2.545,6.733-6.733V103.492h-3.318Z",
    transform: "translate(-140.896 -101.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_817",
    "data-name": "\\u30D1\\u30B9 817",
    d: "M417.7,123.384a6.387,6.387,0,0,0-6.716-6.716,6.821,6.821,0,0,0-6.992,6.276,9.19,9.19,0,0,0-.062,1.059c0,.273.012.539.035.8.357,4.143,3.5,6.508,7.524,6.508a11.363,11.363,0,0,0,5.2-1.152l.393-2.361a10.6,10.6,0,0,1-5.086,1.293c-3.091,0-4.89-1.518-5.171-4.328h10.791A10.648,10.648,0,0,0,417.7,123.384Zm-10.819-.562c.365-2.642,1.967-3.991,4.1-3.991,2.248,0,3.794,1.377,3.99,3.991Z",
    transform: "translate(-330.69 -111.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_818",
    "data-name": "\\u30D1\\u30B9 818",
    d: "M211.888,120.636V113.47l-2.91.378v7.626a5.26,5.26,0,0,1-.1,1.02h0a4.1,4.1,0,0,1-3.8,3.549c-2.154,0-3.318-1.309-3.318-3.492v-.057h-2.91v.668a4.859,4.859,0,0,0,5.122,5.239,5.91,5.91,0,0,0,5.152-2.619v2.183h2.765v-5.47h0Z",
    transform: "translate(-182.713 -108.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_819",
    "data-name": "\\u30D1\\u30B9 819",
    d: "M201.759,113.47l-2.91.378v6.788h2.91Z",
    transform: "translate(-182.712 -108.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_820",
    "data-name": "\\u30D1\\u30B9 820",
    d: "M383.323,97.289l-2.81.45v11.222h2.81Z",
    transform: "translate(-313.795 -97.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_821",
    "data-name": "\\u30D1\\u30B9 821",
    d: "M380.513,145.879h0v6.058h2.81v-6.058h-2.81Z",
    transform: "translate(-313.795 -132.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_822",
    "data-name": "\\u30D1\\u30B9 822",
    d: "M320.515,147.218a2.015,2.015,0,0,1-.41-1.223c0-.04.009-.077.011-.116H317.9c0,.039-.006.077-.006.116a4.2,4.2,0,0,0,1.015,2.751,5.574,5.574,0,0,1,1.6-1.528Z",
    transform: "translate(-268.612 -132.35)",
    fill: "#070203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_823",
    "data-name": "\\u30D1\\u30B9 823",
    d: "M330.988,126.728a4.227,4.227,0,0,0-.753-1.023l-.66-.66h.792a1.105,1.105,0,0,0,0-2.211h-3.042a4.248,4.248,0,0,0-5.639.317l-2.554,2.554a4.227,4.227,0,0,0-.753,1.024h2.856l2.014-2.014a2.038,2.038,0,0,1,2.868,0l2.014,2.014.54.54a2.005,2.005,0,0,1,.579,1.318h0c0,.039.011.076.011.116a2.016,2.016,0,0,1-.59,1.434l-2.554,2.554a2.037,2.037,0,0,1-2.868,0l-1.457-1.457a3.818,3.818,0,0,0-1.613,1.513l1.507,1.507a4.224,4.224,0,0,0,.452.391,4.235,4.235,0,0,0-.452.391l-1.507,1.507a3.821,3.821,0,0,0,1.613,1.514l1.457-1.457a2.037,2.037,0,0,1,2.868,0l2.554,2.554a2.038,2.038,0,0,1,0,2.868l-2.554,2.554a2.037,2.037,0,0,1-2.868,0L320.7,142.02a2.035,2.035,0,0,1-.18-2.657,5.58,5.58,0,0,1-1.6-1.529,4.242,4.242,0,0,0,.222,5.749l2.554,2.554a4.248,4.248,0,0,0,5.994,0l2.554-2.554a4.248,4.248,0,0,0,0-5.994l-2.554-2.554a4.163,4.163,0,0,0-.452-.391,4.209,4.209,0,0,0,.452-.392l2.554-2.554a4.21,4.21,0,0,0,1.238-3c0-.039,0-.077-.006-.116h0A4.22,4.22,0,0,0,330.988,126.728Z",
    transform: "translate(-268.612 -115.057)",
    fill: "#070203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_824",
    "data-name": "\\u30D1\\u30B9 824",
    d: "M260.291,147.218a2.015,2.015,0,0,1-.41-1.223c0-.04.009-.077.011-.116h-2.216c0,.039-.006.077-.006.116a4.2,4.2,0,0,0,1.015,2.751,5.574,5.574,0,0,1,1.6-1.528Z",
    transform: "translate(-225.157 -132.35)",
    fill: "#070203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_825",
    "data-name": "\\u30D1\\u30B9 825",
    d: "M270.764,126.728a4.22,4.22,0,0,0-.753-1.023l-.66-.66h.792a1.105,1.105,0,1,0,0-2.211H267.1a4.248,4.248,0,0,0-5.639.317l-2.554,2.554a4.228,4.228,0,0,0-.753,1.024h2.856l2.015-2.014a2.037,2.037,0,0,1,2.868,0l2.014,2.014.54.54a2,2,0,0,1,.579,1.318h0c0,.039.011.076.011.116a2.015,2.015,0,0,1-.59,1.434l-2.554,2.554a2.037,2.037,0,0,1-2.868,0l-1.457-1.457a3.815,3.815,0,0,0-1.612,1.513l1.506,1.507a4.224,4.224,0,0,0,.452.391,4.235,4.235,0,0,0-.452.391l-1.507,1.507a3.825,3.825,0,0,0,1.613,1.514l1.457-1.457a2.037,2.037,0,0,1,2.868,0l2.554,2.554a2.038,2.038,0,0,1,0,2.868l-2.554,2.554a2.037,2.037,0,0,1-2.868,0l-2.554-2.554a2.034,2.034,0,0,1-.181-2.657,5.58,5.58,0,0,1-1.6-1.529,4.242,4.242,0,0,0,.222,5.749l2.554,2.554a4.248,4.248,0,0,0,5.994,0l2.554-2.554a4.247,4.247,0,0,0,0-5.994l-2.554-2.554a4.166,4.166,0,0,0-.452-.391,4.182,4.182,0,0,0,.452-.392l2.554-2.554a4.211,4.211,0,0,0,1.238-3c0-.039,0-.077-.006-.116h0A4.22,4.22,0,0,0,270.764,126.728Z",
    transform: "translate(-225.157 -115.057)",
    fill: "#070203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_826",
    "data-name": "\\u30D1\\u30B9 826",
    d: "M320.515,157.907a5.536,5.536,0,0,0,6.732-.63L326,156.026a3.777,3.777,0,0,1-4.2.574,3.821,3.821,0,0,1-1.613-1.514,3.775,3.775,0,0,1,0-3.8,3.818,3.818,0,0,1,1.613-1.513,3.778,3.778,0,0,1,4.2.573l1.251-1.251a5.536,5.536,0,0,0-6.732-.63,5.573,5.573,0,0,0-1.6,1.528,5.517,5.517,0,0,0,0,6.381,5.58,5.58,0,0,0,1.6,1.529Z",
    transform: "translate(-268.612 -133.601)",
    fill: "#0081d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_827",
    "data-name": "\\u30D1\\u30B9 827",
    d: "M260.291,157.907a5.536,5.536,0,0,0,6.732-.63l-1.251-1.251a3.777,3.777,0,0,1-4.2.574,3.825,3.825,0,0,1-1.613-1.514,3.773,3.773,0,0,1,0-3.8,3.815,3.815,0,0,1,1.612-1.513,3.778,3.778,0,0,1,4.2.573l1.251-1.251a5.536,5.536,0,0,0-6.732-.63,5.573,5.573,0,0,0-1.6,1.528,5.517,5.517,0,0,0,0,6.381,5.58,5.58,0,0,0,1.6,1.529Z",
    transform: "translate(-225.157 -133.601)",
    fill: "#0081d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ca12c87eb5648cb1902df4ccbeeea5f5.svg";
export { ForwardRef as ReactComponent };